var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    [
      _c(
        "MobileHeader",
        {
          attrs: { slot: "header", "nav-action": "home", "show-cart": "" },
          slot: "header"
        },
        [_vm._v("\n    Burger Boss - " + _vm._s(_vm.restaurant.city) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$style.main }, [
        _c("div", { class: _vm.$style.mainTop }, [
          _c("img", {
            class: _vm.$style.mainLogo,
            attrs: {
              srcset:
                require("@/assets/img/LOGO@2x.png") +
                ", " +
                require("@/assets/img/LOGO.png"),
              src: require("@/assets/img/LOGO.png"),
              alt: "Burger Boss"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.mainBottom },
          [
            _c(
              "VList",
              { class: _vm.$style.productList },
              [
                _vm._l(_vm.sortedProducts, function(product) {
                  return [
                    _c(
                      "VListTile",
                      {
                        key: product.key,
                        class: _vm.$style.productListItem,
                        attrs: { ripple: "" },
                        on: {
                          click: function($event) {
                            return _vm.openConfigurator(product.key)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { class: _vm.$style.productListItemContent },
                          [
                            _c("p", { class: _vm.$style.productListItemText }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(product.name) +
                                  "\n                "
                              ),
                              false
                                ? _c(
                                    "span",
                                    { class: _vm.$style.newProductIcon },
                                    [
                                      _vm._v(
                                        "\n                  new\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("svg", {
                              directives: [{ name: "svg", rawName: "v-svg" }],
                              class: _vm.$style.iconPlus,
                              attrs: {
                                symbol: "menu-btn-icon-plus",
                                size: "28"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.menuIsLoading ? _c("LoadingSpinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileMenu.vue?vue&type=template&id=07f37dbe&
// module id = null
// module chunks = 